/**
 * Enable Bootstrap 5 dropdowns on hover for desktop navigation.
 * Applies only on devices with pointer (not touch).
 * @package spx_agumenda
 */
document.addEventListener('DOMContentLoaded', function () {
    if (window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
        const dropdowns = document.querySelectorAll('.navbar .dropdown');
        dropdowns.forEach(function (dropdown) {
            const menu = dropdown.querySelector('.dropdown-menu');
            dropdown.addEventListener('mouseenter', function () {
                dropdown.classList.add('show');
                if (menu) menu.classList.add('show');
                const toggle = dropdown.querySelector('[data-bs-toggle]');
                if (toggle) toggle.setAttribute('aria-expanded', 'true');
            });
            dropdown.addEventListener('mouseleave', function () {
                dropdown.classList.remove('show');
                if (menu) menu.classList.remove('show');
                const toggle = dropdown.querySelector('[data-bs-toggle]');
                if (toggle) toggle.setAttribute('aria-expanded', 'false');
            });
        });
    }
});
